import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { id: "huv-status-hos" }
const _hoisted_2 = { class: "huv-status-layout" }
const _hoisted_3 = { class: "huv-status-filters" }
const _hoisted_4 = { class: "filter" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", {
  class: "inputLabel",
  for: "agency-id"
}, " Organization ", -1 /* HOISTED */)
const _hoisted_6 = ["value"]
const _hoisted_7 = { class: "filter" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", {
  class: "inputLabel",
  for: "agency-location-id"
}, " Branch ", -1 /* HOISTED */)
const _hoisted_9 = {
  key: 0,
  class: "filter"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", {
  class: "inputLabel",
  for: "team-list"
}, " Team ", -1 /* HOISTED */)
const _hoisted_11 = {
  key: 1,
  class: "filter"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", {
  class: "inputLabel",
  for: "taskFilter"
}, " Task ", -1 /* HOISTED */)
const _hoisted_13 = { class: "filter" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", {
  class: "inputLabel",
  for: "taskStatusFilter"
}, " Task Status ", -1 /* HOISTED */)
const _hoisted_15 = { class: "filter me-auto" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", {
  class: "inputLabel",
  for: "huvSvfFilter"
}, " HUV/SVF ", -1 /* HOISTED */)
const _hoisted_17 = { class: "form-group h-100 d-flex align-items-end" }
const _hoisted_18 = { class: "bg-white rounded mt-2 h-100" }
const _hoisted_19 = { class: "h-100 d-flex flex-column mb-3 mt-2" }
const _hoisted_20 = { class: "table-scroll-wrapper" }
const _hoisted_21 = { class: "table table-responsive-md border border-gray" }
const _hoisted_22 = { class: "bg-table-header" }
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" Branch ")
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" Team ")
const _hoisted_25 = /*#__PURE__*/_createTextVNode(" First Name ")
const _hoisted_26 = /*#__PURE__*/_createTextVNode(" Last Name ")
const _hoisted_27 = /*#__PURE__*/_createTextVNode(" MRN ")
const _hoisted_28 = /*#__PURE__*/_createTextVNode(" Patient Status ")
const _hoisted_29 = /*#__PURE__*/_createTextVNode(" Task ")
const _hoisted_30 = /*#__PURE__*/_createTextVNode(" HUV/SFV ")
const _hoisted_31 = /*#__PURE__*/_createTextVNode(" Task Status ")
const _hoisted_32 = /*#__PURE__*/_createTextVNode(" Visit Date ")
const _hoisted_33 = /*#__PURE__*/_createTextVNode(" Admission Date ")
const _hoisted_34 = /*#__PURE__*/_createTextVNode(" Days Remaining ")
const _hoisted_35 = {
  key: 0,
  class: "table-empty"
}
const _hoisted_36 = ["colspan"]
const _hoisted_37 = /*#__PURE__*/_createElementVNode("h3", null, "No Tasks Found.", -1 /* HOISTED */)
const _hoisted_38 = [
  _hoisted_37
]
const _hoisted_39 = {
  key: 1,
  class: "table-error"
}
const _hoisted_40 = ["colspan"]
const _hoisted_41 = /*#__PURE__*/_createElementVNode("span", { class: "shimmer-loading" }, null, -1 /* HOISTED */)
const _hoisted_42 = [
  _hoisted_41
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MultiSelect = _resolveComponent("MultiSelect")!
  const _component_MultiSelectFilter = _resolveComponent("MultiSelectFilter")!
  const _component_SortableTh = _resolveComponent("SortableTh")!
  const _component_ErrorMessageHandler = _resolveComponent("ErrorMessageHandler")!
  const _component_HuvSfvStatusReportHosRow = _resolveComponent("HuvSfvStatusReportHosRow")!
  const _component_Pagination = _resolveComponent("Pagination")!
  const _component_PageLayout = _resolveComponent("PageLayout")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("header", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _withDirectives(_createElementVNode("select", {
            id: "agency-id",
            class: "form-select pl-1",
            name: "agencies",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedAgency) = $event))
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.agencyOptions, (value, key) => {
              return (_openBlock(), _createElementBlock("option", {
                value: value.value,
                key: key
              }, _toDisplayString(value.name), 9 /* TEXT, PROPS */, _hoisted_6))
            }), 128 /* KEYED_FRAGMENT */))
          ], 512 /* NEED_PATCH */), [
            [_vModelSelect, _ctx.selectedAgency]
          ]),
          _createCommentVNode(" Uncomment this once BE accept multiple agencies "),
          _createCommentVNode(" <MultiSelect\r\n                        :dropDownOptions=\"agencyMultiSelectOptions\"\r\n                        labelText=\"Organizations\"\r\n                        :selectedOptions=\"selectedAgencies\"\r\n                        v-on:updateBranches=\"updateBranchesbyAgency\"\r\n                    /> ")
        ]),
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createVNode(_component_MultiSelect, {
            id: "agency-location-id",
            dropDownOptions: _ctx.branchMultiSelectOptions,
            labelText: "Branches",
            selectedOptions: _ctx.selectedBranches,
            onUpdateBranches: _ctx.updateBranches
          }, null, 8 /* PROPS */, ["dropDownOptions", "selectedOptions", "onUpdateBranches"])
        ]),
        (_ctx.selectedAgency.length && _ctx.selectedBranches.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _hoisted_10,
              _createVNode(_component_MultiSelectFilter, {
                ref: "teamFilter",
                id: "team-list",
                "on-fetch": _ctx.getTeamsList,
                "selected-items": _ctx.selectedTeams,
                "onUpdate:selected-items": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedTeams) = $event)),
                onSelectedItemsUpdated: _ctx.selectedTeamsUpdated,
                name: "Teams"
              }, null, 8 /* PROPS */, ["on-fetch", "selected-items", "onSelectedItemsUpdated"])
            ]))
          : _createCommentVNode("v-if", true),
        (_ctx.selectedAgency.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _hoisted_12,
              _createVNode(_component_MultiSelectFilter, {
                ref: "taskFilter",
                id: "taskFilter",
                "on-fetch": _ctx.getTaskStatusLean,
                "selected-items": _ctx.selectedTask,
                "onUpdate:selected-items": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedTask) = $event)),
                onSelectedItemsUpdated: _ctx.selectedTaskFilterUpdates,
                name: "taskFilter"
              }, null, 8 /* PROPS */, ["on-fetch", "selected-items", "onSelectedItemsUpdated"])
            ]))
          : _createCommentVNode("v-if", true),
        _createElementVNode("div", _hoisted_13, [
          _hoisted_14,
          _createVNode(_component_MultiSelectFilter, {
            ref: "taskStatusFilter",
            id: "taskStatusFilter",
            "on-fetch": _ctx.getHuvSvfTaskStatusOptions,
            "selected-items": _ctx.selectedTaskStatus,
            "onUpdate:selected-items": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedTaskStatus) = $event)),
            onSelectedItemsUpdated: _ctx.selectedTaskStatusFilterUpdates,
            name: "taskStatusFilter"
          }, null, 8 /* PROPS */, ["on-fetch", "selected-items", "onSelectedItemsUpdated"])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _hoisted_16,
          _createVNode(_component_MultiSelectFilter, {
            ref: "huvSvfFilter",
            id: "huvSvfFilter",
            "on-fetch": _ctx.getHuvSvfStatusOptions,
            "selected-items": _ctx.selectedHopeFilter,
            "onUpdate:selected-items": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectedHopeFilter) = $event)),
            onSelectedItemsUpdated: _ctx.selectedHopeFilterUpdates,
            name: "huvSvfFilter"
          }, null, 8 /* PROPS */, ["on-fetch", "selected-items", "onSelectedItemsUpdated"])
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-primary ms-2 mt-4",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.exportStatusList()))
          }, "Export")
        ])
      ]),
      _createElementVNode("main", _hoisted_18, [
        _createVNode(_component_PageLayout, null, {
          content: _withCtx(() => [
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _createVNode(_component_Pagination, {
                  ref: "huvSfvStatusPagination",
                  pageChanged: _ctx.pageChangedCallback,
                  isLoading: _ctx.isLoading,
                  showPageSizeOptions: true,
                  classes: "pagination-footer pb-2",
                  pageSize: _ctx.pageSize,
                  onUpdatePageSizeChanged: _ctx.updatePageSizeChanged
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("table", _hoisted_21, [
                      _createElementVNode("thead", null, [
                        _createElementVNode("tr", _hoisted_22, [
                          _createCommentVNode(" <th></th> "),
                          _createElementVNode("th", null, [
                            _createVNode(_component_SortableTh, {
                              "sort-by": _ctx.sortBy,
                              onSortByUpdated: _ctx.sortByUpdated,
                              "sort-order": _ctx.sortOrder,
                              onSortOrderUpdated: _ctx.sortOrderUpdated,
                              "sort-string": "branch",
                              class: "justify-content-start"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_23
                              ]),
                              _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["sort-by", "onSortByUpdated", "sort-order", "onSortOrderUpdated"])
                          ]),
                          _createElementVNode("th", null, [
                            _createVNode(_component_SortableTh, {
                              "sort-by": _ctx.sortBy,
                              onSortByUpdated: _ctx.sortByUpdated,
                              "sort-order": _ctx.sortOrder,
                              onSortOrderUpdated: _ctx.sortOrderUpdated,
                              "sort-string": "team",
                              class: "justify-content-start"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_24
                              ]),
                              _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["sort-by", "onSortByUpdated", "sort-order", "onSortOrderUpdated"])
                          ]),
                          _createElementVNode("th", null, [
                            _createVNode(_component_SortableTh, {
                              "sort-by": _ctx.sortBy,
                              onSortByUpdated: _ctx.sortByUpdated,
                              "sort-order": _ctx.sortOrder,
                              onSortOrderUpdated: _ctx.sortOrderUpdated,
                              "sort-string": "patientFirstName",
                              class: "justify-content-start"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_25
                              ]),
                              _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["sort-by", "onSortByUpdated", "sort-order", "onSortOrderUpdated"])
                          ]),
                          _createElementVNode("th", null, [
                            _createVNode(_component_SortableTh, {
                              "sort-by": _ctx.sortBy,
                              onSortByUpdated: _ctx.sortByUpdated,
                              "sort-order": _ctx.sortOrder,
                              onSortOrderUpdated: _ctx.sortOrderUpdated,
                              "sort-string": "patientLastName",
                              class: "justify-content-start"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_26
                              ]),
                              _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["sort-by", "onSortByUpdated", "sort-order", "onSortOrderUpdated"])
                          ]),
                          _createElementVNode("th", null, [
                            _createVNode(_component_SortableTh, {
                              "sort-by": _ctx.sortBy,
                              onSortByUpdated: _ctx.sortByUpdated,
                              "sort-order": _ctx.sortOrder,
                              onSortOrderUpdated: _ctx.sortOrderUpdated,
                              "sort-string": "mrn",
                              class: "justify-content-start"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_27
                              ]),
                              _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["sort-by", "onSortByUpdated", "sort-order", "onSortOrderUpdated"])
                          ]),
                          _createElementVNode("th", null, [
                            _createVNode(_component_SortableTh, {
                              "sort-by": _ctx.sortBy,
                              onSortByUpdated: _ctx.sortByUpdated,
                              "sort-order": _ctx.sortOrder,
                              onSortOrderUpdated: _ctx.sortOrderUpdated,
                              "sort-string": "patientStatus",
                              class: "justify-content-start"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_28
                              ]),
                              _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["sort-by", "onSortByUpdated", "sort-order", "onSortOrderUpdated"])
                          ]),
                          _createElementVNode("th", null, [
                            _createVNode(_component_SortableTh, {
                              "sort-by": _ctx.sortBy,
                              onSortByUpdated: _ctx.sortByUpdated,
                              "sort-order": _ctx.sortOrder,
                              onSortOrderUpdated: _ctx.sortOrderUpdated,
                              "sort-string": "task",
                              class: "justify-content-start"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_29
                              ]),
                              _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["sort-by", "onSortByUpdated", "sort-order", "onSortOrderUpdated"])
                          ]),
                          _createElementVNode("th", null, [
                            _createVNode(_component_SortableTh, {
                              "sort-by": _ctx.sortBy,
                              onSortByUpdated: _ctx.sortByUpdated,
                              "sort-order": _ctx.sortOrder,
                              onSortOrderUpdated: _ctx.sortOrderUpdated,
                              "sort-string": "hopeType",
                              class: "justify-content-start"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_30
                              ]),
                              _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["sort-by", "onSortByUpdated", "sort-order", "onSortOrderUpdated"])
                          ]),
                          _createElementVNode("th", null, [
                            _createVNode(_component_SortableTh, {
                              "sort-by": _ctx.sortBy,
                              onSortByUpdated: _ctx.sortByUpdated,
                              "sort-order": _ctx.sortOrder,
                              onSortOrderUpdated: _ctx.sortOrderUpdated,
                              "sort-string": "taskStatus",
                              class: "justify-content-start"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_31
                              ]),
                              _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["sort-by", "onSortByUpdated", "sort-order", "onSortOrderUpdated"])
                          ]),
                          _createElementVNode("th", null, [
                            _createVNode(_component_SortableTh, {
                              "sort-by": _ctx.sortBy,
                              onSortByUpdated: _ctx.sortByUpdated,
                              "sort-order": _ctx.sortOrder,
                              onSortOrderUpdated: _ctx.sortOrderUpdated,
                              "sort-string": "visitDate",
                              class: "justify-content-start"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_32
                              ]),
                              _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["sort-by", "onSortByUpdated", "sort-order", "onSortOrderUpdated"])
                          ]),
                          _createElementVNode("th", null, [
                            _createVNode(_component_SortableTh, {
                              "sort-by": _ctx.sortBy,
                              onSortByUpdated: _ctx.sortByUpdated,
                              "sort-order": _ctx.sortOrder,
                              onSortOrderUpdated: _ctx.sortOrderUpdated,
                              "sort-string": "admissionDate",
                              class: "justify-content-start"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_33
                              ]),
                              _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["sort-by", "onSortByUpdated", "sort-order", "onSortOrderUpdated"])
                          ]),
                          _createElementVNode("th", null, [
                            _createVNode(_component_SortableTh, {
                              "sort-by": _ctx.sortBy,
                              onSortByUpdated: _ctx.sortByUpdated,
                              "sort-order": _ctx.sortOrder,
                              onSortOrderUpdated: _ctx.sortOrderUpdated,
                              "sort-string": "daysRemaining",
                              class: "justify-content-start"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_34
                              ]),
                              _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["sort-by", "onSortByUpdated", "sort-order", "onSortOrderUpdated"])
                          ])
                        ])
                      ]),
                      _createElementVNode("tbody", null, [
                        _createCommentVNode(" EMPTY "),
                        (!_ctx.isLoading && !_ctx.isError && !_ctx.hasData)
                          ? (_openBlock(), _createElementBlock("tr", _hoisted_35, [
                              _createElementVNode("td", { colspan: _ctx.columns }, _hoisted_38, 8 /* PROPS */, _hoisted_36)
                            ]))
                          : _createCommentVNode("v-if", true),
                        _createCommentVNode(" ERROR "),
                        (!_ctx.isLoading && _ctx.isError)
                          ? (_openBlock(), _createElementBlock("tr", _hoisted_39, [
                              _createElementVNode("td", { colspan: _ctx.columns }, [
                                _createVNode(_component_ErrorMessageHandler, {
                                  title: "Frequency Watch list",
                                  onTryAgain: _cache[6] || (_cache[6] = ($event: any) => (_ctx.pageReset()))
                                })
                              ], 8 /* PROPS */, _hoisted_40)
                            ]))
                          : _createCommentVNode("v-if", true),
                        _createCommentVNode(" LOADING "),
                        (_ctx.isLoading)
                          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.loadingCount, (i) => {
                              return (_openBlock(), _createElementBlock("tr", {
                                class: "table-loading",
                                key: i
                              }, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (i) => {
                                  return (_openBlock(), _createElementBlock("td", { key: i }, _hoisted_42))
                                }), 128 /* KEYED_FRAGMENT */))
                              ]))
                            }), 128 /* KEYED_FRAGMENT */))
                          : _createCommentVNode("v-if", true)
                      ]),
                      (!_ctx.isLoading && !_ctx.isError && _ctx.hasData)
                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.page.Items, (item) => {
                            return (_openBlock(), _createElementBlock("tbody", {
                              key: item.PatientId
                            }, [
                              _createVNode(_component_HuvSfvStatusReportHosRow, {
                                statusItem: item,
                                columns: _ctx.columns,
                                application: _ctx.application,
                                selectedAgency: _ctx.selectedAgency,
                                pageReset: _ctx.pageReset
                              }, null, 8 /* PROPS */, ["statusItem", "columns", "application", "selectedAgency", "pageReset"])
                            ]))
                          }), 128 /* KEYED_FRAGMENT */))
                        : _createCommentVNode("v-if", true)
                    ])
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["pageChanged", "isLoading", "pageSize", "onUpdatePageSizeChanged"])
              ])
            ])
          ]),
          _: 1 /* STABLE */
        })
      ])
    ])
  ]))
}